import _ from 'lodash'
let validateObject = {
  'asegurador': {type:'string'},
  'aseguradorId': {type:'string'},
  'prestacion': {type:'string'},
  'prestacionId': {type:'string'},
  'programa': {type:'string'},
  'programaId': {type:'string'},
  'diastoleSentado': {label:'Diastole Sentado', type:'number',range: [50,130], exp: new RegExp(/\b([5-8][0-9]|9[0-9]|1[0-2][0-9]|130)\b/)},
  'diastoleParado': {label:'Diastole Parado', type:'number',range: [50,130], exp:  new RegExp(/\b([5-8][0-9]|9[0-9]|1[0-2][0-9]|130)\b/)},
  'sistoleSentado':{label:'Sistole Sentado', type:'number',range: [80,220], exp:  new RegExp(/\b(8[0-9]|9[0-9]|1[0-9]{2}|2[01][0-9]|220)\b/)},
  'sistoleParado': {label:'Sistole Parado', type:'number',range: [80,220], exp:  new RegExp(/\b(8[0-9]|9[0-9]|1[0-9]{2}|2[01][0-9]|220)\b/)},
  'perimetroAbdominal':{label:'Perimetro Abdominal', type:'number',range: [30,150], exp:  new RegExp(/\b([3-8][0-9]|9[0-9]|1[0-4][0-9]|150)\b/)},
  'frecuencia': {label:'Frecuencia', type:'number',range: [30,150], exp: new RegExp(/\b([3-8][0-9]|9[0-9]|1[0-4][0-9]|150)\b/)},
  'tiempoCincoM': {label:'Diempo de caminata', type:'number',range: [0,200], exp: new RegExp(/\b([0-9]|10)\b/)},
 
}

let validateObj = {
  '0': [80, 220], // presion
  '1': [50, 130], // presion
  '2': [80, 220], // presion
  '3': [50, 130], // presion
  '4': [30, 150], // frecuencia
  '5': [40, 200],  // peso
  '6': [110, 210], // altura
  '7': [60, 150],  // pAbdominal
  '8': [10, 45], // balanceNeuroIMuscular
  '9': [10, 45], // balanceNeuroDMuscular
  '10': [0.5, 1.5], // itbi
  '11': [0.5, 1.5], // itbd
  '12': [4, 18], // vop
  '13': [0, 10], // caminata
  '14': [35, 39], // temperatura
  '15': [1, 100], // grasaCorporal
  '21': [10, 45], // gripi
  '22': [10, 45] // gripd

}
export function ValidateShowModal (arr, individual ) {
 const { 
    asegurador, 
    aseguradorId,
    prestacion,
    prestacionId,
    programa,
    programaId,
    diastoleSentado,
    diastoleParado,
    sistoleSentado,
    sistoleParado,
    perimetroAbdominal,

    frecuencia,
    tiempoCincoM
  } = arr
  const arrayNames =   [   'asegurador', 'aseguradorId', 'prestacion', 'prestacionId', 'programa', 'programaId', 'diastoleSentado', 'diastoleParado', 'sistoleSentado', 'sistoleParado', 'perimetroAbdominal',  'frecuencia', 'tiempoCincoM']
  //  Empty 

  let obj = []
  arrayNames.filter((name)=> {
    if(eval(name) == ''){
      obj.push({ name: `${name}`})
    }
  })

  if(obj.length > 0){
    return {obj, Empty: true}
  }

  
  // Ranges
  let objRange = []
  arrayNames.map((name)=>{
    if(validateObject[name].type === 'number'){
      let e = validateObject[name].exp
      if(!e.test(eval(name)))
        {
          objRange.push({label: `${validateObject[name].label}`, valor: `${eval(name)}`, 'rango': ` El rango deberia estar en ${validateObject[name].range.join(',')}`})
        }
    }
  })
  if(objRange.length > 0){
    return {objRange, Empty: false}
  } else {
    return {Empty: false}
  }
}
export default function ValidateFunction (arr, individual) {
  if (individual) {
    console.log(arr.value, arr.position, validateObj[arr.position])
    if (arr.value) {
      let value = parseFloat(arr.value)
      if (value < validateObj[arr.position][0] || value > validateObj[arr.position][1]) {
        return 'data-input red'
      } else {
        return 'data-input'
      }
    } else {
      return 'data-input red'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Health/ValidateParameters.js